/**
 * Minimal `process` global for browser dependencies.
 *
 * Vite 8 `define` only replaces the static identifier `process.env.NODE_ENV`.
 * Recoil reads `process.env[name]` at module init; json-schema-ref-parser's
 * bundled `path` reads `process.platform` / `process.cwd()`. Those need a real
 * global — not node-stdlib-browser (that package pulls elliptic).
 *
 * Do not overwrite Node's `process` in Vitest.
 */
const browserProcess = {
  env: {
    NODE_ENV: import.meta.env.PROD ? 'production' : import.meta.env.MODE,
  } as Record<string, string | undefined>,
  browser: true,
  version: '',
  versions: { node: '' },
  platform: 'browser',
  pid: 0,
  argv: [] as string[],
  title: 'browser',
  cwd: () => '/',
  nextTick: (fn: (...args: unknown[]) => void, ...args: unknown[]) => {
    queueMicrotask(() => {
      fn(...args);
    });
  },
};

if (!('process' in globalThis)) {
  Object.defineProperty(globalThis, 'process', {
    value: browserProcess,
    configurable: true,
    writable: true,
  });
}
